import { useAuthProvider as useAuthProviderBase } from '@maui-mf/common-react'

export const useAuthProvider = () => {
  const base = useAuthProviderBase()
  const { claims } = base
  const selectedOrg = claims && claims.organizations.find(
    ({ uuid }) => claims.org === uuid
  )

  return { ...base, selectedOrg }
}
